export default (obj) => {
    Object.keys(obj).forEach(function (item) {
        if (null === obj[item] || 'null' === obj[item]) {
            delete obj[item]
        }
    });

    return obj;
}
